/*
 * Package: `@dbh/radio-button-with-theme`.
 *
 */const THEME_KEY_RADIO_WITH_IMAGES="radioWithImages",modifyRadioWithImagesTheme=a=>{let{colors:{grey:b,white:c,greyLight:d},spacing:{sp7:e}}=a;return {[THEME_KEY_RADIO_WITH_IMAGES]:{active:{backgroundColor:b,borderWidth:"0.3rem"},inactive:{backgroundColor:c},iconWrapper:{width:e,height:e},shadowColor:d,borderColor:b,desktopUseSpaceAround:!1}}};

export { modifyRadioWithImagesTheme as default };
